import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KPI } from "@/components/Primitives";
import { Building2 } from "lucide-react";

export default function ClientPortal() {
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/portal/overview").then(r => setO(r.data)); }, []);
  if (!o || !o.client) return <div className="text-zinc-500 text-sm">Loading portal…</div>;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Client Portal (preview)</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1 flex items-center gap-2"><Building2 size={22} className="text-blue-400"/> {o.client.name}</h1>
        <p className="text-sm text-zinc-500 mt-1">Read-only view exposed to client administrators · {o.client.industry} · {o.client.country}</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Assets" value={o.assets} testid="portal-assets"/>
        <KPI label="Open Tickets" value={o.open_tickets} testid="portal-tickets"/>
        <KPI label="Compliance" value={o.compliance_findings} tone="warn" testid="portal-comp"/>
        <KPI label="Security" value={o.security_findings} tone="warn" testid="portal-sec"/>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md p-5">
        <div className="font-display font-medium mb-2">Available in client portal</div>
        <ul className="text-sm text-zinc-400 list-disc list-inside space-y-1">
          <li>View Assets, Tickets, Compliance Status, Security Status</li>
          <li>Download Reports (PDF / Excel / PowerPoint)</li>
          <li>View Contracts and Licenses</li>
          <li>Executive Dashboards (read-only)</li>
        </ul>
      </div>
    </div>
  );
}
